(() => {
  'use strict';

  const pad = (value) => String(value).padStart(2, '0');

  const isoLocal = (date) => {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  };

  const parseDate = (value) => {
    const [year, month, day] = String(value || '').split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  const formatDateJa = (value) => {
    if (!value) return '－';

    return new Intl.DateTimeFormat('ja-JP', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'short',
    }).format(parseDate(value));
  };

  document.querySelectorAll('[data-srs-request]').forEach((root) => {
    const form = root.querySelector('[data-srs-request-form]');
    const submitUrl = root.dataset.submitUrl || '';
    const slotsUrl = root.dataset.slotsUrl || '';
    const bookingDays = Number(root.dataset.bookingDays || 60);
    const token = new URLSearchParams(window.location.search).get('token') || '';

    const dateInput = root.querySelector('[data-requested-date]');
    const timeInput = root.querySelector('[data-requested-time]');
    const slotList = root.querySelector('[data-slot-list]');
    const slotMessage = root.querySelector('[data-slots-message]');
    const status = root.querySelector('[data-request-message]');
    const modal = root.querySelector('[data-confirm-modal]');
    const summary = root.querySelector('[data-confirm-summary]');
    const submitButton = form.querySelector('.srs-request__submit');
    const finalSubmit = root.querySelector('[data-confirm-submit]');
    const loadButton = root.querySelector('[data-load-reservation]');
    const editableSections = root.querySelectorAll('[data-change-step]');

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const maxDate = new Date(today);
    maxDate.setDate(maxDate.getDate() + bookingDays);

    let monthCursor = new Date(today.getFullYear(), today.getMonth(), 1);
    let guests = { adults: 2, children: 0 };
    let originalReservation = null;
    let pendingPayload = null;
    let loadingReservation = false;

    const setStatus = (message, type = '') => {
      status.textContent = message;
      status.className = `srs-request__status${type ? ` is-${type}` : ''}`;
    };

    const setLoadedState = (loaded) => {
      editableSections.forEach((section) => {
        section.hidden = !loaded;
      });

      submitButton.hidden = !loaded;
    };

    const totalGuests = () => guests.adults + guests.children;

    const isRegularClosingDay = (date) => {
      if (date.getDay() !== 1) return false;

      const weekOfMonth = Math.floor((date.getDate() - 1) / 7) + 1;
      return weekOfMonth === 2 || weekOfMonth === 4;
    };

    const setCounter = (type, value, reloadSlots = false) => {
      const minimum = type === 'adults' ? 1 : 0;
      const maximum = 9;
      guests[type] = Math.max(minimum, Math.min(maximum, Number(value) || 0));

      root.querySelector(`[data-counter-value="${type}"]`).textContent = guests[type];
      root.querySelector(`[data-counter-input="${type}"]`).value = guests[type];

      if (reloadSlots && dateInput.value) {
        timeInput.value = '';
        loadSlots(dateInput.value);
      }
    };

    root.querySelectorAll('[data-counter-action]').forEach((button) => {
      button.addEventListener('click', () => {
        const type = button.dataset.counterType;
        const delta = button.dataset.counterAction === 'increase' ? 1 : -1;
        setCounter(type, guests[type] + delta, true);
      });
    });

    const renderCalendar = () => {
      const title = root.querySelector('[data-calendar-title]');
      const grid = root.querySelector('[data-calendar-grid]');
      const previousButton = root.querySelector('[data-calendar-prev]');
      const nextButton = root.querySelector('[data-calendar-next]');

      title.textContent = `${monthCursor.getFullYear()}年${monthCursor.getMonth() + 1}月`;
      grid.innerHTML = '';

      const firstDay = new Date(
        monthCursor.getFullYear(),
        monthCursor.getMonth(),
        1,
      ).getDay();

      const daysInMonth = new Date(
        monthCursor.getFullYear(),
        monthCursor.getMonth() + 1,
        0,
      ).getDate();

      for (let index = 0; index < firstDay; index += 1) {
        const empty = document.createElement('span');
        empty.className = 'srs-calendar__day srs-calendar__day--empty';
        grid.appendChild(empty);
      }

      for (let day = 1; day <= daysInMonth; day += 1) {
        const date = new Date(
          monthCursor.getFullYear(),
          monthCursor.getMonth(),
          day,
        );

        date.setHours(0, 0, 0, 0);

        const value = isoLocal(date);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'srs-calendar__day';
        button.textContent = day;
        button.dataset.date = value;

        const regularClosingDay = isRegularClosingDay(date);
        button.disabled = date < today || date > maxDate || regularClosingDay;

        if (regularClosingDay) {
          button.classList.add('is-closed');
          button.title = '定休日（第2・第4月曜日）';
          button.setAttribute('aria-label', `${day}日 定休日`);
        }

        if (dateInput.value === value) {
          button.classList.add('is-selected');
        }

        button.addEventListener('click', () => {
          dateInput.value = value;
          timeInput.value = '';
          renderCalendar();
          loadSlots(value);
        });

        grid.appendChild(button);
      }

      const firstAllowedMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastAllowedMonth = new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);

      previousButton.disabled = monthCursor <= firstAllowedMonth;
      nextButton.disabled = monthCursor >= lastAllowedMonth;
    };

    root.querySelector('[data-calendar-prev]').addEventListener('click', () => {
      monthCursor = new Date(
        monthCursor.getFullYear(),
        monthCursor.getMonth() - 1,
        1,
      );
      renderCalendar();
    });

    root.querySelector('[data-calendar-next]').addEventListener('click', () => {
      monthCursor = new Date(
        monthCursor.getFullYear(),
        monthCursor.getMonth() + 1,
        1,
      );
      renderCalendar();
    });

    const renderSlots = (data, preferredTime = '') => {
      slotList.innerHTML = '';
      slotMessage.hidden = true;
      slotList.hidden = false;

      const groups = { lunch: [], dinner: [] };

      (data.slots || []).forEach((slot) => {
        const groupName = slot.session === 'lunch' ? 'lunch' : 'dinner';
        groups[groupName].push(slot);
      });

      const labels = { lunch: 'ランチ', dinner: 'ディナー' };

      Object.entries(groups).forEach(([session, slots]) => {
        if (!slots.length) return;

        const group = document.createElement('section');
        group.className = 'srs-slot-group';

        const heading = document.createElement('h4');
        heading.textContent = labels[session];

        const list = document.createElement('div');
        list.className = 'srs-slot-list';

        slots.forEach((slot) => {
          const button = document.createElement('button');
          const preservesOriginalSlot = Boolean(
            originalReservation
            && dateInput.value === originalReservation.reservation_date
            && slot.time === originalReservation.reservation_time
            && totalGuests() <= originalReservation.adults + originalReservation.children
          );
          const unavailable = !preservesOriginalSlot
            && !['available', 'few'].includes(slot.status);

          button.type = 'button';
          button.className = 'srs-slot';
          button.dataset.time = slot.time;
          button.disabled = unavailable;
          button.innerHTML = unavailable
            ? `${slot.time}<small>${slot.status === 'full' ? '満席' : '受付外'}</small>`
            : slot.time;

          if (!unavailable && (timeInput.value === slot.time || preferredTime === slot.time)) {
            timeInput.value = slot.time;
            button.classList.add('is-selected');
          }

          button.addEventListener('click', () => {
            timeInput.value = slot.time;
            root.querySelectorAll('.srs-slot').forEach((element) => {
              element.classList.remove('is-selected');
            });
            button.classList.add('is-selected');
          });

          list.appendChild(button);
        });

        group.append(heading, list);
        slotList.appendChild(group);
      });

      if (!slotList.children.length) {
        slotList.hidden = true;
        slotMessage.hidden = false;
        slotMessage.classList.add('is-error');
        slotMessage.textContent = 'この日は選択できる時間がありません。別の日をお選びください。';
      }
    };

    async function loadSlots(date, preferredTime = '') {
      slotList.hidden = true;
      slotMessage.hidden = false;
      slotMessage.classList.remove('is-error');
      slotMessage.textContent = '予約可能時間を確認しています…';

      if (!slotsUrl) {
        slotMessage.classList.add('is-error');
        slotMessage.textContent = '空席確認APIが設定されていません。';
        return false;
      }

      try {
        const url = new URL(slotsUrl);
        url.searchParams.set('date', date);
        url.searchParams.set('guests', String(totalGuests()));

        if (originalReservation?.id) {
          url.searchParams.set('exclude_reservation_id', originalReservation.id);
        }

        const response = await fetch(url.toString(), {
          method: 'GET',
          headers: { Accept: 'application/json' },
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok || data.success !== true) {
          throw new Error(data.error || 'slots_failed');
        }

        if (data.closed || data.online_booking_enabled === false) {
          slotMessage.classList.add('is-error');
          slotMessage.textContent = data.notice || 'この日はオンライン予約を受け付けていません。';
          return false;
        }

        renderSlots(data, preferredTime);
        return true;
      } catch (error) {
        console.error('[srs-request] slot load failed', error);
        slotMessage.classList.add('is-error');
        slotMessage.textContent = '予約可能時間を取得できませんでした。時間をおいて再度お試しください。';
        return false;
      }
    }

    const reservationLookupPayload = () => {
      const formData = new FormData(form);

      return {
        action: 'lookup',
        token,
        reservation_number: formData.get('reservation_number'),
        email: formData.get('email'),
        phone: formData.get('phone'),
      };
    };

    const applyReservation = async (reservation) => {
      originalReservation = {
        id: reservation.id,
        reservation_number: reservation.reservation_number,
        customer_name: reservation.customer_name,
        phone: reservation.phone,
        email: reservation.email,
        reservation_date: reservation.reservation_date,
        reservation_time: String(reservation.reservation_time || '').slice(0, 5),
        adults: Number(reservation.adults || 1),
        children: Number(reservation.children || 0),
        customer_notes: reservation.customer_notes || '',
      };

      form.elements.reservation_number.value = originalReservation.reservation_number;
      form.elements.customer_name.value = originalReservation.customer_name;
      form.elements.phone.value = originalReservation.phone;
      form.elements.email.value = originalReservation.email;
      form.elements.request_message.value = originalReservation.customer_notes;

      dateInput.value = originalReservation.reservation_date;
      timeInput.value = originalReservation.reservation_time;
      setCounter('adults', originalReservation.adults, false);
      setCounter('children', originalReservation.children, false);

      const originalDate = parseDate(originalReservation.reservation_date);
      monthCursor = new Date(originalDate.getFullYear(), originalDate.getMonth(), 1);
      renderCalendar();
      setLoadedState(true);

      await loadSlots(
        originalReservation.reservation_date,
        originalReservation.reservation_time,
      );

      setStatus('現在のご予約内容を読み込みました。変更する項目を選択してください。', 'success');
    };

    const loadReservation = async () => {
      if (loadingReservation) return;

      if (!submitUrl) {
        setStatus('変更APIが設定されていません。テーマ設定をご確認ください。', 'error');
        return;
      }

      loadingReservation = true;
      setStatus('ご予約情報を確認しています…');

      if (loadButton) {
        loadButton.disabled = true;
        loadButton.textContent = '確認しています…';
      }

      try {
        const response = await fetch(submitUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(reservationLookupPayload()),
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok || data.success !== true || !data.reservation) {
          throw new Error(data.message || data.error || 'lookup_failed');
        }

        await applyReservation(data.reservation);
      } catch (error) {
        console.error('[srs-request] reservation lookup failed', error);
        setLoadedState(false);
        setStatus(
          error.message === 'change_deadline_passed'
            ? 'ご予約時間まで3時間を切っているため、変更はお電話でご相談ください。'
            : 'ご予約情報を確認できませんでした。予約番号と連絡先をご確認ください。',
          'error',
        );
      } finally {
        loadingReservation = false;

        if (loadButton) {
          loadButton.disabled = false;
          loadButton.textContent = '予約情報を読み込む';
        }
      }
    };

    loadButton?.addEventListener('click', loadReservation);

    const currentPayload = () => {
      const formData = new FormData(form);
      const payload = Object.fromEntries(formData.entries());

      return {
        ...payload,
        action: 'change',
        token,
        requested_adults: Number(payload.requested_adults),
        requested_children: Number(payload.requested_children),
        client_timestamp: Date.now(),
      };
    };

    const hasChanges = (payload) => {
      if (!originalReservation) return false;

      return (
        payload.requested_date !== originalReservation.reservation_date ||
        payload.requested_time !== originalReservation.reservation_time ||
        Number(payload.requested_adults) !== originalReservation.adults ||
        Number(payload.requested_children) !== originalReservation.children ||
        String(payload.request_message || '').trim() !== String(originalReservation.customer_notes || '').trim()
      );
    };

    const validate = () => {
      setStatus('');

      if (!originalReservation) {
        setStatus('先に現在の予約情報を読み込んでください。', 'error');
        return false;
      }

      if (!form.reportValidity()) return false;

      if (!dateInput.value) {
        setStatus('変更後の日付を選択してください。', 'error');
        root.querySelector('[data-request-calendar]').scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        return false;
      }

      if (!timeInput.value) {
        setStatus('変更後の時間を選択してください。', 'error');
        slotMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }

      if (totalGuests() >= 10) {
        setStatus('10名以上の変更は店舗までお電話ください。', 'error');
        return false;
      }

      const payload = currentPayload();

      if (!hasChanges(payload)) {
        setStatus('変更された項目がありません。日時・人数・備考のいずれかを変更してください。', 'error');
        return false;
      }

      return true;
    };

    const appendSummaryRow = (label, value, className = '') => {
      const term = document.createElement('dt');
      const description = document.createElement('dd');

      term.textContent = label;
      description.textContent = value;

      if (className) {
        term.classList.add(className);
        description.classList.add(className);
      }

      summary.append(term, description);
    };

    const openModal = (payload) => {
      summary.innerHTML = '';

      appendSummaryRow('現在の日付', formatDateJa(originalReservation.reservation_date), 'is-before');
      appendSummaryRow('変更後の日付', formatDateJa(payload.requested_date), 'is-after');
      appendSummaryRow('現在の時間', originalReservation.reservation_time, 'is-before');
      appendSummaryRow('変更後の時間', payload.requested_time, 'is-after');
      appendSummaryRow(
        '現在の人数',
        `大人${originalReservation.adults}名・子ども${originalReservation.children}名`,
        'is-before',
      );
      appendSummaryRow(
        '変更後の人数',
        `大人${payload.requested_adults}名・子ども${payload.requested_children}名`,
        'is-after',
      );
      appendSummaryRow('備考', payload.request_message || 'なし');

      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      finalSubmit.focus();
    };

    const closeModal = () => {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    };

    root.querySelectorAll('[data-modal-close]').forEach((element) => {
      element.addEventListener('click', closeModal);
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!validate()) return;

      pendingPayload = currentPayload();
      openModal(pendingPayload);
    });

    finalSubmit.addEventListener('click', async () => {
      if (!pendingPayload || !originalReservation) return;

      finalSubmit.disabled = true;
      finalSubmit.textContent = '変更しています…';
      submitButton.disabled = true;

      try {
        const response = await fetch(submitUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-SRS-Request-ID': crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`,
          },
          body: JSON.stringify(pendingPayload),
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok || data.success !== true) {
          throw new Error(data.message || data.error || 'change_failed');
        }

        closeModal();
        await applyReservation(data.reservation);
        setStatus('予約内容を変更しました。確認メールをお送りしています。', 'success');
        status.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        console.error('[srs-request] change failed', error);
        closeModal();

        const messages = {
          slot_full: '選択した時間は満席になりました。別の時間をお選びください。',
          change_deadline_passed: 'ご予約時間まで3時間を切っているため、変更はお電話でご相談ください。',
          reservation_conflict: '予約内容が別の操作で更新されています。ページを再読み込みしてください。',
        };

        setStatus(
          messages[error.message] || '変更できませんでした。内容をご確認のうえ、もう一度お試しください。',
          'error',
        );
      } finally {
        finalSubmit.disabled = false;
        finalSubmit.textContent = 'この内容で変更する';
        submitButton.disabled = false;
        pendingPayload = null;
      }
    });

    const reservationNumber = new URLSearchParams(window.location.search).get('reservation_number');

    if (reservationNumber) {
      root.querySelector('[data-reservation-number-input]').value = reservationNumber;
    }

    root.querySelector('[data-client-timestamp]').value = String(Date.now());
    setLoadedState(false);
    renderCalendar();

    if (token) {
      loadReservation();
    }
  });
})();
